<script lang="ts">
  import { observe } from "$lib/actions/observe";

  let { sectionLabel = "", headline = "", events = [] as Array<{ year: string; title: string; description: string }> } = $props();
</script>

<section>
  <div class="container">
    {#if sectionLabel}
      <div class="section-divider fade-up" use:observe>
        <span class="section-label">{sectionLabel}</span>
        <h2>{headline}</h2>
      </div>
    {/if}
    <div class="timeline fade-up" use:observe style="max-width:600px;margin:0 auto">
      {#each events as event}
        <div class="timeline-item">
          <span class="year">{event.year}</span>
          <h3>{event.title}</h3>
          <p class="copy" style="font-size:0.9rem">{event.description}</p>
        </div>
      {/each}
    </div>
  </div>
</section>
